import type { ShopUpgradeDefinition } from './types';

const COSTS = [90, 150, 240, 360, 520];

export const SHOP: ShopUpgradeDefinition[] = [
  {
    id: 'barrage',
    name: 'Barrage',
    shortName: 'BARRAGE',
    description: 'All towers deal +20% damage per level.',
    color: '#ff6b4a',
    costs: COSTS,
  },
  {
    id: 'tempo',
    name: 'Tempo',
    shortName: 'TEMPO',
    description: 'Towers fire 10% faster and muster minions 12% faster per level.',
    color: '#ffd23a',
    costs: COSTS,
  },
  {
    id: 'muster',
    name: 'Muster',
    shortName: 'MUSTER',
    description: 'Minions gain +15% health and +10% damage per level.',
    color: '#63c93c',
    costs: COSTS,
  },
  {
    id: 'greed',
    name: 'Greed',
    shortName: 'GREED',
    description: 'Essence income pays +15% and summons cost 6% less per level.',
    color: '#4ad9c8',
    costs: COSTS,
  },
];

export const SHOP_BY_ID: Record<string, ShopUpgradeDefinition> = Object.fromEntries(SHOP.map((s) => [s.id, s]));
export const SHOP_MAX_LEVEL = COSTS.length;
